import { render } from "./SalesByCustomer.vue?vue&type=template&id=7bbc0834&ts=true"
import script from "./SalesByCustomer.vue?vue&type=script&lang=ts"
export * from "./SalesByCustomer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__